export const FeaturePeriod = {
    mainLayer: Boolean,
    label: String,
    context: String,
    range: {
        start: Date,
        end: Date
    },
    limits: {
        start: Date,
        end: Date
    },
};



// WEBPACK FOOTER //
// ./src/scripts/core/selection/types/feature-period.type.js